$(document).ready(function(){
    $("#owl-example").owlCarousel();
    console.log('entred');
});


// WEBPACK FOOTER //
// src/js/custom.js